import React from 'react';
import { Card } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../../reports/reportHelper';

const EmissionTrendChart = ({ trend }) => {
  const { labels, datasets } = trend;
  const { t } = useTranslation(); 

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="font-weight-bold mb-1">
          {t('Emission Intensity Over Time')}
        </div>

        <div style={{ height: 280 }}>
          <Line
            data={{
              labels,
              datasets: [
                {
                  label: datasets.emissionIntensity.label,
                  data: datasets.emissionIntensity.data,
                  borderColor: '#22C55E',
                  fill: false,
                },
                {
                  label: datasets.sectorBenchmark.label,
                  data: datasets.sectorBenchmark.data,
                  borderColor: '#3B82F6',
                  borderDash: [6, 6],
                  fill: false,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              legend: { position: 'bottom' },
              tooltips: {
                filter: function (tooltipItem, data) {
                  let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                  return value !== 0;
                },
                callbacks: {
                  label: (tooltipItem, data) => {
                    const { label } = data.datasets[tooltipItem.datasetIndex];
                    const value = formatNumber(tooltipItem.value);
                    if (tooltipItem.datasetIndex !== 0) {
                      return t('{{label}}: {{number}} tCO2e/£M', { label, number: value });
                    }
                    return t('{{label}}: {{number}} tCO2e', { label, number: value });
                  },
                }
              },
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default EmissionTrendChart;
